module.exports = __webpack_public_path__ + "static/img/jj_bg_01.f90a11f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solve/jj_bg_01.png
// module id = hr/E
// module chunks = 1